import Image from 'next/image';
import React from 'react';
import Breadcrumb from '../../../shared-components/Breadcrumb/Breadcrumb';
import BlogHero from '../../BlogHero/BlogHero';
import BlogRelatedTourCard from './BlogRelatedTourCard/BlogRelatedTourCard';
import { useMediaQuery } from '../../../hooks/mediaQuery';
import BlogRelatedTourSwiper from './BlogRelatedTourCard/BlogRelatedTourSwiper';
import SwiperCore, { Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { styled } from 'styled-components';
import Link from 'next/link';
import BlogTopTours from './BlogTopTours/BlogTopTours';
import RelatedBlogs from './RelatedBlogs/RelatedBlogs';
import MARKDOWN from '../../../utils/react-markdown';
import TableOfContents from './TableOfContent';
import getHeadings from '../../../utils/getHeadings';
import { convertTimestampToYYYYMMDD } from '../../../utils/getDateTime';
import { replaceTripshepherdWithSeeSight } from '../../../utils/trip-sheppered-text';
SwiperCore.use([Navigation]);

const StyledMarkdownContainer = styled.div`
  line-height: 1.8rem;
  color: #444;

  font-size: 16px;
  font-weight: 400;
  line-height: 28px;

  @media (min-width: 1024px) {
    font-size: 16px;
    line-height: 28px;
  }
  @media (min-width: 1380px) {
    font-size: 17px;
    line-height: 28px;
  }
  @media (min-width: 1600px) {
    font-size: 18px;
    line-height: 30px;
  }

  /* Paragraph styling */
  p {
    color: #444;
    font-size: 16px;
    font-weight: 400;
    line-height: 28px;
    margin-bottom: 16px;

    @media (min-width: 1024px) {
      font-size: 16px;
      line-height: 28px;
    }
    @media (min-width: 1380px) {
      font-size: 17px;
      line-height: 28px;
    }
    @media (min-width: 1600px) {
      font-size: 18px;
      line-height: 30px;
    }
  }

  /* Link styling */
  a {
    color: #4285f4;
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 28px;
    text-decoration: underline;
    &:hover {
      color: #0056b3;
    }
    @media (min-width: 1024px) {
      font-size: 15px;
      line-height: 28px;
    }
    @media (min-width: 1380px) {
      font-size: 16px;
      line-height: 28px;
    }
    @media (min-width: 1600px) {
      font-size: 18px;
      line-height: 30px;
    }
  }

  /* h2 Heading styling */
  h2 {
    color: #222;
    font-family: 'Roboto', sans-serif;
    font-weight: 600;
    font-size: 20px;
    margin: 1.2rem 0 1rem;
    text-align: left !important;
    @media (min-width: 1024px) {
      font-size: 22px;
      margin: 0.75rem 0;
      font-weight: 400;
    }
    @media (min-width: 1380px) {
      font-size: 24px;
      margin: 0.75rem 0;
    }
    @media (min-width: 1600px) {
      font-size: 28px;
      margin: 1.2rem 0 1rem;
    }
  }

  /* h3 Heading styling */
  h3 {
    color: #222;
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 600;
    margin: 2rem 0 1rem 0;
    text-align: left !important;
    line-height: 22px;
    @media (min-width: 1024px) {
      font-size: 18px;
      font-weight: 400;
    }
    @media (min-width: 1380px) {
      font-size: 22px;
    }
    @media (min-width: 1600px) {
      font-size: 24px;
    }
  }

  /* Bullet point (ul, li) styling */
  ul {
    max-width: 1000px;
    font-size: 16px;
    margin: 1rem 0;
    line-height: 28px;
    font-weight: 400;
    letter-spacing: 0.5px;
    list-style-type: disc;
    padding-left: 1.5rem;
    li {
      margin-left: 1rem; /* Optional: adds space between bullet and text */
    }

    @media (min-width: 640px) {
      font-size: 17px;
      margin: 1.5rem 0;
    }
    @media (min-width: 1024px) {
      font-size: 17px;
      margin: 1.5rem 0;
    }
    @media (min-width: 1380px) {
      font-size: 18px;
      margin: 2rem 0;
    }
    @media (min-width: 1600px) {
      font-size: 20px;
      margin: 2.5rem 0;
    }
  }

  /* Image styling */
  img {
    width: 100%;
    height: auto;
    border-radius: 10px;
    margin: 2rem 0rem;

    @media (min-width: 768px) {
      font-size: 17px;
      margin: 1.5rem 0;
      height: auto;
    }
    @media (min-width: 1024px) {
      font-size: 17px;
      margin: 1.5rem 0;
      height: 430px;
    }
    @media (min-width: 1280px) {
      font-size: 18px;
      margin: 1rem 0;
      height: 450px;
    }
    @media (min-width: 1380px) {
      font-size: 18px;
      margin: 1rem 0;
      height: 480px;
    }
    @media (min-width: 1600px) {
      font-size: 20px;
      margin: 1rem 0;
      height: 530px;
    }
  }
  .cta-two-tone {
    background-image: url('https://res.cloudinary.com/see-sight-tours/image/upload/w_600/v1684227123/banner-background_mp3bnq.webp');
    max-width: 600px;
    padding: 1rem 5%;
    aspect-ratio: 10 / 4;
    margin: 2rem auto;

    background-size: cover;
    background-position: center;
    height: auto;
    display: flex;
    align-items: start;
    justify-content: space-evenly;
    flex-direction: column;
    min-height: 200px;
    border-radius: 20px;
    justify-content: center;
    align-items: center;

    @media (max-width: 700px) {
      width: 100%;
      aspect-ratio: 5 / 1;
      min-height: 180px;
      justify-content: space-evenly;
    }
    @media (min-width: 768px) {
      // margin-bottom: 3rem;
      gap: 1.75rem;
    }

    p {
      color: white;
      font-size: 16px;
      padding: 0rem 1rem;
      text-align: center;
      line-height: 20px;

      @media (min-width: 640px) {
        font-size: 20px;
        line-height: 20px;
      }

      @media (min-width: 1024px) {
        margin-top: 0;
        font-size: 24px;
        line-height: 32px;
      }
    }

    .button-container {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 0 0 20px 20px;

      a {
        background: #d14f4d;
        border-radius: 20px;
        width: 45%;
        padding: 0.5rem 0;
        display: flex;
        justify-content: center;
        align-items: center;
        text-decoration: none;
        color: white !important;
        font-size: 21px;
        font-weight: bold;

        @media (max-width: 550px) {
          width: 60%;
          font-size: 18px;
        }

        &:hover {
          background: #fd3f3c;
        }
      }
    }
  }
`;

export const Blog = ({ blog }: any) => {
  const isMobileOrTablet = useMediaQuery(1023); // Adjust breakpoint as needed

  const breadcrumbLinks = [
    { title: 'Blog', hrefLink: '/blog' },
    {
      title: blog?.category.name,
      hrefLink: `/blog/category/${blog?.category.slug}`
    },
    {
      title:
        blog?.page_title.includes('-') &&
        blog?.page_title.split('-').pop().trim() === 'See Sight Tours'
          ? blog.page_title.split('-').slice(0, -1).join('-').trim()
          : blog.page_title,
      hrefLink: `/blog/${blog.slug}`
    }
  ];

  //we have to preprocess blog content nce it is edited from FireCMS to make its format consistent to old blogs format
  function preprocessContent(content: string) {
    //  Extract and format CTA sections
    content = content?.replace(
      /^(.*?)(\n{2,})?\[Book Now\]\(([^)]+)\)/gm,
      (match, title, _, url) => `
            <div className="center">
                <div className="cta-two-tone">
                    <p>${title.trim()}</p>
                    <div className="button-container">
                        <a href="${url}" target="_blank">Book Now</a>
                    </div>
                </div>
            </div>
        `
    );

    // Normalize Markdown image format by removing any backslashes (\)
    content = content?.replace(
      /!\\\[(.*?)\\\]\((https?:\/\/[^\s)]+)\)/g,
      '![$1]($2)'
    );

    // Wrap images with the required centered format and optional photo credit
    content = content?.replace(
      /!\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g,
      (match, altText, url) => `
         <center>
           <a href="${url}" target="_blank">
             <img src="${url}" alt="${altText}" />
           </a>
         </center>
       `
    );

    // Convert Markdown headers and other elements to HTML
    content = content?.replace(/^###\s(.+)/gm, '<h3>$1</h3>'); // ### to <h3>
    content = content?.replace(/^##\s(.+)/gm, '<h2>$1</h2>'); // ## to <h2>
    content = content?.replace(/^#\s(.+)/gm, '<h1>$1</h1>'); // # to <h1>

    // Wrap plain text paragraphs with <p> tags
    content = content
      ?.split(/\n\n+/)
      .map(paragraph => {
        // Skip elements already wrapped in HTML tags
        if (
          paragraph.startsWith('<h') ||
          paragraph.startsWith('<center>') ||
          paragraph.startsWith('<div')
        ) {
          return paragraph;
        }
        return `<p>${paragraph.trim()}</p>`;
      })
      .join('\n');

    return content?.trim();
  }

  function convertContentToHTML(blogContent: any): string {
    const contentParts: string[] = [];

    if (Array.isArray(blogContent)) {
      // Iterate through the blog content
      blogContent.forEach(item => {
        // Convert text to HTML
        let textHTML = item.text;

        // Replace headers
        textHTML = textHTML.replace(/^###\s(.+)/gm, '<h3>$1</h3>'); // ### to <h3>
        textHTML = textHTML.replace(/^##\s(.+)/gm, '<h2>$1</h2>'); // ## to <h2>
        textHTML = textHTML.replace(/^#\s(.+)/gm, '<h1>$1</h1>'); // # to <h1>

        // Replace unordered lists (- or * list items)
        textHTML = textHTML.replace(/^\s*-\s(.+)/gm, '<li>$1</li>'); // - to <li>
        textHTML = textHTML.replace(/(<li>.+<\/li>)/gm, '<ul>$1</ul>'); // wrap <ul> around <li>s

        // Replace links
        textHTML = textHTML.replace(
          /\[([^\]]+)\]\(([^)]+)\)/g,
          '<a href="$2" target="_blank">$1</a>'
        );

        // Replace images
        textHTML.replace(
          /!\[([^\]]*)\]\(([^()]*\([^()]*\)[^()]*)\)/g,
          '<img src="$2" alt="$1"/>'
        );

        // Wrap textHTML in <p> tags if necessary
        textHTML = `<p>${textHTML.trim()}</p>`;

        // Add textHTML to contentParts
        contentParts.push(textHTML);

        // Check if there's a CTA and convert it to HTML
        if (item.cta.title) {
          const ctaHTML = `
           <div class="center">
             <div class="cta-two-tone">
               <p>${item.cta.title}</p>
               <div class="button-container">
                 <a href="${item.cta.cta_link}" target="_blank">${item.cta.cta}</a>
               </div>
             </div>
           </div>
         `;
          // Add CTA HTML to contentParts
          contentParts.push(ctaHTML);
        }
      });

      // Join all parts into a single HTML string
      return contentParts.join('');
    } else {
      let textHTML = blogContent;

      // Replace Markdown headers with HTML tags
      textHTML = textHTML.replace(/^###\s(.+)/gm, '<h3>$1</h3>');
      textHTML = textHTML.replace(/^##\s(.+)/gm, '<h2>$1</h2>');
      textHTML = textHTML.replace(/^#\s(.+)/gm, '<h1>$1</h1>');

      // Replace list items with HTML list tags
      textHTML = textHTML.replace(/^\s*-\s(.+)/gm, '<li>$1</li>');
      // Wrap list items in <ul> if there are any <li> tags
      if (/<li>.+<\/li>/.test(textHTML)) {
        textHTML = textHTML.replace(/(<li>.+?<\/li>)/gm, '<ul>$1</ul>');
      }

      // Replace Markdown images with HTML img tags wrapped in anchor tags
      textHTML = textHTML.replace(
        /!\[([^\]]*)\]\(([^)]+)\)/g,
        '<img src="$2" alt="$1" />'
      );

      // Replace Markdown links with HTML anchor tags
      textHTML = textHTML.replace(
        /\[([^\]]+)\]\(([^)]+)\)/g,
        '<a href="$2" target="_blank">$1</a>'
      );

      // Wrap the content in <p> tags and trim whitespace
      textHTML = `<p>${textHTML.trim()}</p>`;
      contentParts.push(textHTML);

      return contentParts.join('');
    }
  }

  let contentWithHtmlTags;

  // Check if blog.content is an array or a string
  if (Array.isArray(blog.content)) {
    // If it's an array, call convertContentToHTML directly (For new Blogs)
    contentWithHtmlTags = convertContentToHTML(blog.content);
  } else {
    // If it's a string, first call preprocessContent, then convertContentToHTML (For Old Blogs)
    const preprocessedContent = preprocessContent(blog.content);
    contentWithHtmlTags = convertContentToHTML(preprocessedContent);
  }

  //Assign headings to make table of content
  const content = getHeadings(contentWithHtmlTags);

  return (
    <div className="flex flex-col gap-10">
      <div
        className={`flex flex-col ${
          blog?.relatedProducts?.length > 0
            ? `px-5 sm:px-8 lg:px-10 xl:px-20 2xl:px-32 3xl:px-52`
            : `px-5 sm:px-10 md:px-10 lg:px-24 xl:px-48 2xl:px-56 3xl:px-80`
        } py-5 gap-4 relative`}
      >
        <Breadcrumb
          breadcrumbLinks={breadcrumbLinks}
          alignContent="justify-left"
          isArrowSeparator={true}
        />
        <div className="flex lg:gap-6 xl:gap-8 mb-10 sm:mb-5 lg:mb-20">
          <div
            className={`${
              blog?.relatedProducts?.length > 0
                ? `w-full lg:w-[70%] xl:w-[70%]`
                : `w-full`
            } flex flex-col gap-5`}
          >
            <BlogHero
              title={
                blog?.page_title.includes('-') &&
                blog?.page_title.split('-').pop().trim() === 'See Sight Tours'
                  ? blog.page_title.split('-').slice(0, -1).join('-').trim()
                  : blog.page_title
              }
              imageAlt={blog?.featured_image.alt_text}
              snippet={blog?.category.name}
              slug={blog?.slug}
              media={blog?.featured_image.image}
            />

            <div className="flex items-center gap-3 flex-wrap sm:flex-none">
              <span className="text-xs sm:text-base">
                by &nbsp;
                <Link
                  className="text-[#222222] text-xs sm:text-base font-normal sm:leading-10 cursor-pointer hover:text-darkBlue"
                  href={`/author/${blog?.author.slug}`}
                  target="_blank"
                >
                  {blog?.author.name}
                </Link>
              </span>

              <div className="w-5 h-px bg-[#222222] hidden sm:flex"></div>
              <div className="flex gap-1.5 items-center">
                <Image
                  src="/black-calendar-icon.svg"
                  alt="calender-icon"
                  width={18}
                  height={18}
                />
                <div className="text-[#222222] text-xs sm:text-base font-normal sm:leading-10">
                  {convertTimestampToYYYYMMDD(blog?.publication_date)}
                </div>
              </div>
            </div>

            {isMobileOrTablet && blog?.relatedProducts?.length > 0 && (
              <div className="">
                <BlogRelatedTourSwiper products={blog.relatedProducts} />
              </div>
            )}

            <TableOfContents content={content} />

            <div
              className={`${
                blog?.relatedProducts.length > 0
                  ? `px-0 lg:px-[20px] 2xl:px-[40px]`
                  : `px-0 2xl:px-[65px]`
              } text-left md:text-justify`}
            >
              <StyledMarkdownContainer>
                <MARKDOWN
                  content={
                    content?.htmlWithIds
                      ? replaceTripshepherdWithSeeSight(content?.htmlWithIds)
                      : contentWithHtmlTags
                  }
                />
              </StyledMarkdownContainer>
            </div>
          </div>

          {!isMobileOrTablet && (
            <div
              className={`${blog?.relatedProducts?.length > 0 && 'w-[35%]'} `}
            >
              <div className="gap-4 3xl:gap-7 flex-col sticky top-20 lg:flex hidden">
                {blog?.relatedProducts
                  ?.slice(0, 3)
                  ?.map((product: any, index: any) => (
                    <BlogRelatedTourCard product={product} key={index} />
                  ))}
              </div>
            </div>
          )}
        </div>
      </div>
      <RelatedBlogs relatedBlogs={blog.relatedBlogs} />
      {blog?.relatedProducts?.length > 0 && (
        <BlogTopTours relatedProducts={blog.relatedProducts} />
      )}
    </div>
  );
};
